import { Injectable } from "@angular/core";
import { ApiService } from "../http/api.service";
import { MaintenanceConfigResponse } from "../../shared/backend-api.types";
import { apiPath } from "../../shared/api-path.const";

@Injectable({
  providedIn: "root",
})
export class MaintenanceApiService {
  constructor(private readonly apiService: ApiService) {}

  public async isMaintenanceModeActive(): Promise<boolean> {
    const response = await this.apiService.sendGetRequest<MaintenanceConfigResponse>(
      `${apiPath.config}/maintenance`,
      undefined,
    );
    return response.enabled;
  }
}
